import { render, staticRenderFns } from "./NewRoleModal.vue?vue&type=template&id=1659a5c8&lang=pug"
import script from "./NewRoleModal.vue?vue&type=script&lang=js"
export * from "./NewRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports